import { combineReducers }  	from 'redux-immutablejs';
import domain               	from './domain';
import ui               		from './ui';

export default combineReducers({
	ui,
	domain
});